import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { style } from './style';

export interface VendorUserPresenceProps {
  vendorName: string | undefined;
  vendorImage: string | undefined;
  isOnline: boolean;
}
export const VendorUserPresence: FC<VendorUserPresenceProps> = (props) => {
  const { vendorName, vendorImage, isOnline } = props;
  const styles = style();
  const className = isOnline ? 'online' : 'offline';

  return (
    <div className={css(styles.channelImageContainer)}>
      <img className={css(styles.channelImage)} src={vendorImage} alt={vendorName}></img>
      <span className={css(styles.channelUserPresence, styles[className])}></span>
    </div>
  );
};
